<ng-template #template let-item="item">
  {{item.name}}
</ng-template>
